/**
 * @file     timing.ts
 * @readme   ./CLAUDE.md
 * @purpose  Submission timing analysis hook, flags suspiciously fast form submissions.
 */
'use client';

import { useRef, useCallback } from 'react';

export function useSpamTiming(minSeconds: number = 3) {
  const mountedAt = useRef(Date.now());

  const isTooFast = useCallback((): boolean => {
    const elapsed = (Date.now() - mountedAt.current) / 1000;
    return elapsed < minSeconds;
  }, [minSeconds]);

  const getElapsedSeconds = useCallback((): number => {
    return (Date.now() - mountedAt.current) / 1000;
  }, []);

  return { isTooFast, getElapsedSeconds };
}
